var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle",class:{ 'toggle--disabled': _vm.disabled },on:{"click":_vm.toggle}},[_c('div',{staticClass:"toggle__track",class:{ 'toggle__track--on': _vm.value }}),(_vm.label)?_c('span',{staticClass:"toggle__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }